import { STATIC_TEXT_APP } from "mobx-store/storeInterfaces/staticTextInterface";

const staticTextPath = '/staticText';
export const getStaticTexts = (app: STATIC_TEXT_APP) => `${staticTextPath}?app=${app}`;
export const createStaticText = `${staticTextPath}`;
export const getStaticTextByKey = (key: string, app: STATIC_TEXT_APP) => `${staticTextPath}/${app}/${key}`;
export const updateStaticText = (key: string, app: STATIC_TEXT_APP) => `${staticTextPath}/${app}/${key}`;
